import throttle from "lodash/throttle";
import React from "react";
import ReactDOM from "react-dom";
import actions from "js/main/actions";
import config from "js/main/config";
import locale from "js/main/locale";
import localeStore from "js/stores/localeStore";
import BackboneMixin from "js/views/BackboneMixin";

const getRect= function(element) {
  element.style.display= "block";
  let left= 0,
  top= 0,
  width= element.offsetWidth,
  height= element.offsetHeight,
  current= element;
  while(current && !isNaN(current.offsetLeft) && !isNaN(current.offsetTop)){
      left+= current.offsetLeft - current.scrollLeft;
      top+= current.offsetTop - current.scrollTop;
      current= current.offsetParent;
  }
  let right= window.innerWidth - left - width - 18,
  bottom= window.innerHeight - top - height;

  element.style.display= "";
  return {top, right, bottom, left, width, height};
}

class Footer extends React.Component {
  handleLangChange = (event) => {
    actions.changeLanguage(event.target.value);
  };

  render() {
    const lang = localeStore.lang;
    return <footer ref="footer">
      <div className="container">
        <ul>
          <li><a href={`/page/${lang}/agbs`}>{locale.guestTos}</a></li>
          <li><a href={`/page/${lang}/datenschutz`}>{locale.privacyPolicy}</a></li>
        </ul>
        <ul>
          <li><a href={`/page/${lang}/links`}>Links</a></li>
          <li><a href={`/page/${lang}/impressum`}>{locale.imprint}</a></li>
        </ul>
        <ul className="social">
          <li>

            <div className="langSelect">
              <select onChange={this.handleLangChange} value={lang}>
                <option value="de">Deutsch</option>
                <option value="en">English</option>
              </select>
            </div>

            <div className="social-icons">

              <a href="https://www.youtube.com/user/NDurban18" className="socialBtn" target="_blank">
                <img src="/assets/images/youtube.svg" alt="YouTube" width="32" height="32" />
              </a>

              <a href="https://www.facebook.com/urbanbnb/" className="socialBtn" target="_blank">
                <img src="/assets/images/facebook.svg" alt="Facebook" width="32" height="32" />
              </a>

              <a href="https://www.instagram.com/urbanbnb/" className="socialBtn" target="_blank">
                <img src="/assets/images/instagram.svg" alt="Instagram" width="32" height="32" />
              </a>
            
            </div>

            <div className="social-seperator"></div>

            <a href="/blog" className="socialBtn">
              <img src="/assets/images/bnb.blog.svg" alt="BnB Blog" width="32" height="32" />
              <span className="BnB-Blog">BnB Blog</span>
            </a>
          </li>
        </ul>
      </div>
    </footer>;
  }
}

export default Footer;
